module.exports = __webpack_public_path__ + "img/bell-circle-outline.d0e1dd3.svg";